import React, { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { v4 as uuidv4 } from 'uuid';

export interface ICheckboxControlProps {
  /**
   * An optional id for the. If none is given, one is generated.
   */
  id?: string;
  /**
   * An optional initial state.
   */
  checked?: boolean;
  /**
   * The label to show next to the checkbox.
   */
  label: string;
  /**
   * Optional classname to apply.
   */
  className?: string;
  /**
   * An optional callback function when the checkbox is toggled.
   */
  onChange?: (value: boolean) => void;
}

/**
 * Component for displaying a checkbox.
 */
export const CheckboxControl = ({ id, checked, label, className, onChange }: ICheckboxControlProps) => {

  const checkboxId = id || uuidv4();

  const onCheckboxChanged = (checked: boolean) => {
    onChange?.(checked);
  };

  return (
    <div className={"custom-control custom-checkbox" + (className ? ' ' + className : '')}>
      <input
        className="custom-control-input"
        type="checkbox"
        id={checkboxId}
        onChange={e => onCheckboxChanged(e.target.checked)}
        checked={checked}
      />
      <label 
        htmlFor={checkboxId}
        className="custom-control-label"
      >
        {ReactHtmlParser(label)}
      </label>
    </div>
  );
};
